<template>
    <div class="teachingVideo_wrap">
        <!-- 单个视频集合 -->
        <div class="video_wrap">
            <div class="video_box" @click="openVideo(item)" v-for="item in videoList" :key="item.id">
                <img :src="item.imageUrl">
                <div class="item_content">
                    <div class="item_title">{{item.title}}</div>
                    <div class="flex-between item_bottom">
                        <div>{{item.username}}(转载)</div>
                        <div>{{item.createTime}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page_wrap">
            <el-pagination  layout="prev, pager, next" :page-size="6"  @current-change="getVideoList" :current-page.sync="pages.currentPage" :total="pages.total"></el-pagination>
        </div>
        <el-dialog
            :title="videoTitle"
            :visible.sync="videoVisible"
            center
            width="70%"
        >
            <video controls="controls" ref="videoWrap" :key="videoTitle" :poster="poster" width="100%">
                <source :src="videoSrc" type="video/mp4">
            </video>
        </el-dialog>
    </div>
</template>

<script>
import { cloudVideo } from '../../utils/api';

export default {
    data() {
        return {
            videoVisible:false,
            videoTitle:'',
            videoSrc:'',
            poster:"",
            pages:{
                currentPage:1,
                total:10
            },
            videoList:[]
        };
    },
    mounted(){
        this.getVideoList()
    },
    destroyed(){
        // this.$refs.videoWrap.pause()
    },
    methods:{
        //打开视频
        openVideo(item){
            this.videoTitle = item.title
            this.videoSrc = item.videoUrl
            this.poster = item.imageUrl
            this.videoVisible = true
        },

        //获取视频列表
        getVideoList(){
            let params = {
                page:this.pages.currentPage,
                size:6
            }
            cloudVideo(params).then(res => {
                this.videoList = res.data.list;
                this.pages.total = res.data.totalCount;
            }).catch(err=>{})
        },

    }
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__title{
    font-size: 30px;
    font-weight: 600;
    color: #5278F7;
}
/deep/.el-pagination .btn-prev{
    background: none;
}
/deep/.el-pagination .btn-next{
    background: none;
}
/deep/ .number{
    font-size: 22px;
    font-weight: 50;
    color: #909399;
    background: none;
}
.page_wrap{
    text-align: center;
    margin-bottom: 20px;
}
.teachingVideo_wrap {
    width: 100%;
    box-sizing: border-box;
    padding: 0px 200px;
    margin-top: 60px;

    .video_wrap{
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    .video_box {
        width: 430px;
        height: 320px;
        // margin-right: 30px;
        margin-bottom: 50px;
        box-shadow: 0px 2px 4px rgba(189, 204, 255, 0.3);
        border-radius: 5px;
        overflow: hidden;
        background: #ffffff;
        .item_content{
            box-sizing: border-box;
            padding: 0px 20px;
            .item_title{
                color: #5278F7;
                font-weight: bold;
                height: 46px;
                line-height: 46px;
                font-size: 22px;
            }
            .item_bottom{
                height: 40px;
                line-height: 40px;
                font-size: 16px;
                font-family: 'Segoe UI';
                color: #3C3C3C ;
            }
        }
        img {
            width: 100%;
            margin-top: -23px;
        }

    }
    .video_box:hover {
        box-shadow: 1px 5px 11px -2px rgba(0, 0, 0, 0.2);
        -webkit-box-shadow: 1px 5px 11px -2px rgba(0, 0, 0, 0.2);
        -moz-box-shadow: 1px 5px 11px -2px rgba(0, 0, 0, 0.2);
        cursor: pointer;
    }
    // ul li:nth-child(3n+3)
}
.teachingVideo_wrap div:nth-child(3n + 3) {
    margin-right: 0;
}
</style>
